import { combineReducers } from '@reduxjs/toolkit';
import { bonosSlice } from 'src/slices/bonos/bonosSlice';
import authReducer from 'src/slices/authSlice';

const rootReducer = combineReducers({
  bonos: bonosSlice.reducer,
  auth: authReducer
});

export default rootReducer;
